import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import Layout from '../../components/layout/layout';
import { supabase } from '../../lib/supabase';
import AuthModal from '../../components/auth/auth-modal';
import Button from '../../components/ui/button';

export default function TarifsPage() {
  const [user, setUser] = useState<any>(null);
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  useEffect(() => {
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user || null);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <Layout>
      <div className="min-h-[80vh] flex items-center justify-center py-20">
        <div className="container-custom">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-8 text-transparent bg-clip-text bg-gradient-to-r from-[#d03484] to-[#d47254]">
              Nos offres sont simples.<br />
              Notre méthode efficace.
            </h1>

            {user ? (
              <div className="space-y-12">
                <p className="text-xl text-neutral-700">
                  Mais nos tarifs ne sont pas publics. Pourquoi ? Parce qu'on ne vend pas des CV. On sécurise vos recrutements.
                </p>

                <div className="mt-12 space-y-8 text-left bg-white rounded-2xl p-8 shadow-lg">
                  <h2 className="text-2xl font-bold mb-6 text-center">
                    👉 Accédez à nos 3 offres exclusives :
                  </h2>

                  <div className="space-y-8">
                    <div className="p-6 bg-gradient-to-r from-pink-50 to-purple-50 rounded-xl">
                      <h3 className="text-xl font-bold mb-2">#Essentiel : simple, rapide, garanti</h3>
                      <p className="text-neutral-700">
                        Pour les entreprises qui veulent recruter efficacement sans se ruiner.
                      </p>
                    </div>

                    <div className="p-6 bg-gradient-to-r from-blue-50 to-green-50 rounded-xl">
                      <h3 className="text-xl font-bold mb-2">#ModulR : remboursé ou remplacé</h3>
                      <p className="text-neutral-700">
                        Une formule flexible avec garantie de résultat.
                      </p>
                    </div>

                    <div className="p-6 bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl">
                      <h3 className="text-xl font-bold mb-2">#Progressive : zéro engagement, zéro stress</h3>
                      <p className="text-neutral-700">
                        Idéal pour les startups et scale-ups qui veulent grandir sereinement.
                      </p>
                    </div>
                  </div>

                  <div className="text-center mt-12">
                    <Button
                      variant="gradient"
                      size="lg"
                      onClick={() => window.location.href = '/infos/contact'}
                    >
                      Planifier un appel découverte
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="space-y-8">
                <p className="text-xl text-neutral-700">
                  Mais nos tarifs ne sont pas publics. Pourquoi ? Parce qu'on ne vend pas des CV. On sécurise vos recrutements.
                </p>

                <div className="bg-white rounded-2xl p-8 shadow-lg">
                  <h2 className="text-2xl font-bold mb-6">
                    Connectez-vous pour découvrir nos offres
                  </h2>
                  <Button
                    variant="gradient"
                    size="lg"
                    onClick={() => setIsAuthModalOpen(true)}
                  >
                    Accéder aux tarifs
                  </Button>
                </div>
              </div>
            )}
          </motion.div>
        </div>
      </div>

      <AuthModal
        isOpen={isAuthModalOpen}
        onClose={() => setIsAuthModalOpen(false)}
      />
    </Layout>
  );
}